import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { API_URL } from '../../config';
import { authLogout }  from '../../store/authSlice';
import './Logout.css';

const Logout = () => {
	const { t } = useTranslation();
    const token = useSelector(state => state.auth.token);
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const logout = async () => {
		setIsLoading(true);
        try {
		    await axios.get(API_URL + '/logout');
        } catch (error) {
            console.log(error.message);
        }
        delete axios.defaults.headers.common['Authorization'];
        document.body.removeAttribute('scheme');
		dispatch(authLogout());
        setIsLoading(false);
	};

	return (
        <React.Fragment>
        {isLoading ? <span className='Logout'>...</span> :
            <React.Fragment>
            {token && <span className='Logout' onClick={logout}>{t('logout.title')}</span>}
            </React.Fragment>
        }
        </React.Fragment>
	);
};

export default Logout;
